import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { UseCasesSection } from './components/UseCasesSection';
import { TomosSection } from './components/TomosSection';
import { BonusesSection } from './components/BonusesSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { UrgencyBanner } from './components/UrgencyBanner';
import { PricingSection } from './components/PricingSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { Footer } from './components/Footer';
import { SocialProofPopup } from './components/SocialProofPopup';
const PIXEL_ID = '1904779843432668';
export function App() {
  useEffect(() => {
    // Meta Pixel initialization
    const f = window as any;
    if (f.fbq) return;
    const n: any = f.fbq = function (...args: any[]) {
      n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    f.fbq('init', PIXEL_ID);
    f.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen bg-polo-navy text-white font-sans selection:bg-polo-gold/30 selection:text-white" data-id="element-0">
      <main data-id="element-1">
        <HeroSection data-id="element-2" />
        <UseCasesSection data-id="element-3" />
        <TomosSection data-id="element-4" />
        <BonusesSection data-id="element-5" />
        <TestimonialsSection data-id="element-6" />
        <UrgencyBanner data-id="element-7" />
        <PricingSection data-id="element-8" />
        <GuaranteeSection data-id="element-9" />
        <FAQSection data-id="element-10" />
      </main>
      <Footer data-id="element-11" />

      {/* Interactive Elements */}
      <SocialProofPopup data-id="element-12" />
    </div>;
}